import { Accordion, Container, Image } from "react-bootstrap";

import Button from "../components/button";
import { getAnnouncementImages } from "../utils/announcementImages";

const announcementImages = getAnnouncementImages();

function formatAnnouncementHeading(label) {
  const m = /^(\d{4})-(\d{1,2})-(\d{1,2})$/.exec(label);
  if (m) {
    const [, y, mo, d] = m;
    return `${y}年${Number(mo)}月${Number(d)}日 公告`;
  }
  return `公告（${label}）`;
}

function Content() {
  return (
    <>
      <div className="banner">
        <h1 className="text-banner">診所公告</h1>
      </div>

      <Button />
      <Container className="announce-page py-4">
        {announcementImages.length === 0 ? (
          <p className="text-mid text-center py-5">目前尚無公告。</p>
        ) : (
          <Accordion className="announce-accordion" defaultActiveKey="0">
            {announcementImages.map(({ key, src, label }, index) => (
              <Accordion.Item eventKey={String(index)} key={key}>
                <Accordion.Header className="announce-accordion-header">
                  {formatAnnouncementHeading(label)}
                </Accordion.Header>
                <Accordion.Body className="announce-accordion-body">
                  <figure className="announce-figure mb-0">
                    <Image
                      src={src}
                      alt={`診所公告 ${label}`}
                      fluid
                      className="announce-page-image"
                    />
                  </figure>
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        )}
      </Container>
    </>
  );
}

export default Content;
